export const initMasonry = (props) => {
  const { containerSelector, itemSelector, columnWidth, gutter, horizontalOrder} = props;

  const stagger = document.querySelector(containerSelector);

  if (!stagger) {
    return;
  }
  else {
    const msnry = new Masonry(stagger, {
      itemSelector: itemSelector,
      columnWidth: columnWidth,
      percentPosition: true,
      gutter: gutter,
      horizontalOrder: horizontalOrder,
    });
    imagesLoaded(stagger).on('progress', () => {
      msnry.layout();
    });
    return msnry;
  }
};;
